import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["thumbnail"]

  connect() {
    // Controller is connected
  }

  openModal(event) {
    const layoutType = event.currentTarget.dataset.layoutType
    const thumbnail = event.currentTarget.querySelector('img')
    const title = event.currentTarget.querySelector('.layout-label').textContent

    // Set modal content
    document.getElementById('modalPreviewImage').src = thumbnail.src
    document.getElementById('modalPreviewTitle').textContent = title
    document.getElementById('modalPreviewDescription').textContent = this.getDescription(layoutType)

    // Show modal
    const modal = new Modal(document.getElementById('homeScreenLayoutPreviewModal'))
    modal.show()
  }

  getDescription(layoutType) {
    const descriptions = {
      'one': 'Horizon Clean - Clean, minimalist horizontal layout with streamlined navigation',
      'two': 'Horizon Axis - Horizontal layout with centered axis and balanced content distribution',
      'three': 'Horizon Square - Horizontal layout with square grid-based content organization',
      'four': 'Horizon Frame - Horizontal layout with framed content sections and borders',
      'five': 'Atlas Pillar - Vertical pillar-based layout with stacked content sections'
    }
    return descriptions[layoutType] || 'Layout preview'
  }
}
